/** Player category nav follows the public category API order and fields. */

export function isUploadedCategoryImage(icon) {
  return /^(data:image\/|https?:\/\/|\/)/i.test(String(icon || '').trim());
}

/** Same keyword match the original category artwork used. */
export function originalCategoryIconKey(id = '', name = '') {
  const s = `${id} ${name}`.toLowerCase();
  if (/hot|popular|trending/.test(s)) return 'hot';
  if (/sport|cricket|football/.test(s)) return 'sports';
  if (/live\s*casino|casino/.test(s)) return 'casino';
  if (/slot/.test(s)) return 'slots';
  if (/crash|aviator/.test(s)) return 'crash';
  if (/table|poker|blackjack|roulette/.test(s)) return 'table';
  if (/fish/.test(s)) return 'fishing';
  if (/arcade/.test(s)) return 'arcade';
  if (/lotter|keno/.test(s)) return 'lottery';
  return 'games';
}

export function playerCategoryNav(rows) {
  return (Array.isArray(rows) ? rows : [])
    .filter((row) => row && row.enabled !== false)
    .map((row) => ({
      id: String(row.id || ''),
      panelId: String(row.panelId || row.id || ''),
      name: String(row.name || '').trim(),
      icon: String(row.icon || ''),
      position: Number(row.position) || 0,
      enabled: true,
      isHot: !!row.isHot,
    }));
}
